/* Fetchy: extras can never be bought on their own.
   Extras are products tagged fetchy-addon (handles below) or cart lines with the _ck_addon property.
   Crochet Pattern PDF is digital and buyable alone, so it is NOT in ADDONS.
   1. The cart page and drawer render [data-cn-addon-guard] / [data-fx-guard] when the cart only holds extras;
      this removes those extras and blocks checkout.
   2. On every page load, back/forward visit and tab return, /cart.js is checked; an extras-only cart is emptied.
   3. Every checkout button, checkout link and express pay button checks the live cart first.
   Server-side note: theme code can't stop a typed /checkout URL or a /cart/<id>:1 permalink; see SETUP.md. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ADDONS = ['shipping-protection', '90-day-warranty', 'mystery-box-gift'];
  var EXPRESS = 'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, .shopify-payment-button, [data-shopify="payment-button"]';
  var busy = false, blocked = false;

  function isAddon(it) {
    return ADDONS.indexOf(it.handle) > -1 || !!(it.properties && it.properties._ck_addon);
  }
  function addonOnly(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    for (var i = 0; i < cart.items.length; i++) if (!isAddon(cart.items[i])) return false;
    return true;
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function empty(keys) {
    if (!keys.length || busy) return Promise.resolve();
    busy = true;
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () { window.location.reload(); }).catch(function () { busy = false; });
  }
  function clean() {
    var g = document.querySelector('[data-cn-addon-guard]');
    if (!g || busy) return;
    var keys = Array.prototype.map.call(g.querySelectorAll('[data-cn-addon-key]'), function (n) { return n.getAttribute('data-cn-addon-key'); });
    empty(keys);
  }
  function check() {
    return getCart().then(function (cart) {
      blocked = addonOnly(cart);
      if (blocked) { empty(cart.items.map(function (it) { return it.key; })); return false; }
      return true;
    }).catch(function () { return !blocked; });
  }
  function shownBlocked() {
    return !!document.querySelector('[data-cn-addon-guard], [data-fx-guard], [data-fx-content][data-blocked="true"]');
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var isCheckout = f && (f.id === 'cart-form' || (e.submitter && e.submitter.name === 'checkout') || f.querySelector('[name="checkout"]'));
    if (!isCheckout || f.getAttribute('data-fx-checked') === '1') return;
    e.preventDefault();
    if (shownBlocked()) { clean(); check(); return; }
    check().then(function (ok) {
      if (!ok) return;
      f.setAttribute('data-fx-checked', '1');
      if (!f.querySelector('input[type="hidden"][name="checkout"]')) {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h);
      }
      HTMLFormElement.prototype.submit.call(f);
    });
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('a[href*="/checkout"]');
    var express = e.target.closest(EXPRESS);
    if (!link && !express) return;
    if (blocked || shownBlocked()) { e.preventDefault(); e.stopPropagation(); clean(); check(); return; }
    if (link) {
      e.preventDefault();
      var href = link.href;
      check().then(function (ok) { if (ok) window.location.href = href; });
    }
  }, true);

  new MutationObserver(clean).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', function () { busy = false; check(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) check(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { clean(); check(); });
  else { clean(); check(); }
  window.FetchyAddonGuard = { check: check };
})();
